class ScanError extends Error {}

export default ScanError
